import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { APPARATUS_DEFAULT } from '../constants';

// Returns merged apparatus list (Firestore overrides + defaults)
export function useApparatus() {
  const [overrides, setOverrides] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'apparatus'), orderBy('order', 'asc'));
    return onSnapshot(q, (snap) => {
      const map = {};
      snap.docs.forEach((d) => { map[d.data().unit] = { id: d.id, ...d.data() }; });
      setOverrides(map);
      setLoading(false);
    });
  }, []);

  const units = APPARATUS_DEFAULT.map((def, i) => {
    const over = overrides[def.unit];
    return { ...def, ...over, order: over?.order ?? i, _key: def.unit };
  });

  return { units, loading };
}
